import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-2" }, " 🙌 Toutes les catégories ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex my-auto me-1 small ms-auto" }, " Voir plus ", -1)
const _hoisted_3 = { class: "d-flex my-auto" }
const _hoisted_4 = { class: "bg-secondary text-nowrap rounded px-3 text-primary fw-semibold" }

import { ComputedRef, computed, defineComponent } from 'vue';
import { useIonRouter } from '@ionic/vue';
import { Swiper, SwiperSlide } from 'swiper/vue';

import { TCategory } from '@/typings/classes/library.class';
import { useStore } from '@/store';

import categoriesEmoji from '@/assets/json/categories-icon.json';
import { chevronForwardOutline } from 'ionicons/icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'LibraryCarouselByCategory',
  setup(__props) {

const router = useIonRouter();

const goToCategory = (id: number) => router.push(`/library/category/${id}`);
const navigateToAllCategories = () => router.push('/library/categories');

const store = useStore();
const categories: ComputedRef<TCategory[]> = computed(
  () => store?.getters['library/categories'] ?? [],
);

const displayTextWidth = (text: string, font: string): number => {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  if (context) {
    context.font = font;
    const metrics = context.measureText(text);
    return metrics.width;
  } return 0;
};

const slidesOptions = categories.value.map(({ displayName, id }) => ({
  id,
  displayName,
  emoji: categoriesEmoji.find(({ id: categoryId }) => categoryId === id)?.emoji,
  key: `library-category-${id}-card`,
  width: `${displayTextWidth(displayName, '15px Montserrat') + 92}px`,
}));


defineComponent({
  name: 'LibraryByRecipeTimeCarousel',
});

return (_ctx: any,_cache: any) => {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_row = _resolveComponent("ion-row")!

  return (_openBlock(), _createBlock(_component_ion_row, { class: "mb-5" }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_col, { size: "9" }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_ion_col, { size: "3" }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "d-flex flex-row small w-100 mt-1",
            onClick: navigateToAllCategories
          }, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_ion_icon, { icon: _unref(chevronForwardOutline) }, null, 8, ["icon"])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_unref(Swiper), { "slides-per-view": "auto" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(slidesOptions), (slide) => {
            return (_openBlock(), _createBlock(_unref(SwiperSlide), {
              key: slide.key,
              style: _normalizeStyle({ width: slide.width }),
              onClick: ($event: any) => (goToCategory(slide.id))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, _toDisplayString(slide.emoji) + " " + _toDisplayString(slide.displayName), 1)
              ]),
              _: 2
            }, 1032, ["style", "onClick"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})